import { SourcePill } from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

export interface CalendarSourcePillProps {
  microsoft: boolean;
  google: boolean;
}

/**
 * Where this week came from, on the page it came to.
 *
 * "Waar komt deze data vandaan?" is the first question anyone asks of an
 * agenda, and "waar maak ik hier een afspraak aan?" is the second. Both are
 * answered here rather than left to be guessed: the calendar fills this page by
 * itself, and Wundo writes nothing back into it.
 *
 * It names the calendars the user actually connected, and both of them when
 * there are two — a promise about "je agenda" that names the wrong one reads as
 * a promise about somebody else's.
 */
export function CalendarSourcePill({ microsoft, google }: CalendarSourcePillProps) {
  if (!microsoft && !google) return null;

  const label =
    microsoft && google
      ? m.agenda_source_both()
      : microsoft
        ? m.agenda_source_microsoft()
        : m.agenda_source_google();

  return (
    <SourcePill
      infoLabel={m.agenda_source_info()}
      notes={[
        {
          label: m.agenda_source_mirror_title(),
          description: m.agenda_source_mirror_body(),
        },
        {
          label: m.agenda_source_readonly_title(),
          description: m.agenda_source_readonly_body(),
        },
      ]}
    >
      {label}
    </SourcePill>
  );
}
